/*! Product mobile gallery dots — sync with product-images active media */
(function () {
  'use strict';

  var SELECTORS = {
    section: '[data-section-type="product"]',
    images: 'product-images',
    mediaList: '[data-product-media-list]',
    media: '[data-product-image], [data-media-id].product__slide, .product__slide',
    dotsWrap: '[data-product-mobile-dots]',
    dot: '[data-mobile-dot]',
  };

  var ATTR = {
    activeMedia: 'data-active-media',
    mediaId: 'data-media-id',
  };

  var CLASS = {
    active: 'is-active',
  };

  function initDots(wrap) {
    var section = wrap.closest(SELECTORS.section);
    if (!section) return;

    var images = section.querySelector(SELECTORS.images);
    if (!images) return;

    var mediaList = images.querySelector(SELECTORS.mediaList);
    var dots = wrap.querySelectorAll(SELECTORS.dot);

    function setActive(mediaId) {
      if (!mediaId) return;
      dots.forEach(function (dot) {
        var active = dot.getAttribute(ATTR.mediaId) === mediaId;
        dot.classList.toggle(CLASS.active, active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function scrollMediaIntoView(mediaId) {
      if (!mediaList) return;
      var slide = mediaList.querySelector('[' + ATTR.mediaId + '="' + mediaId + '"]');
      if (slide && typeof slide.scrollIntoView === 'function') {
        slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (event) {
        event.preventDefault();
        var id = dot.getAttribute(ATTR.mediaId);
        if (!id || dot.classList.contains(CLASS.active)) return;

        images.dispatchEvent(
          new CustomEvent('theme:media:select', {
            bubbles: true,
            detail: { id: id },
          })
        );

        // Slider mode (no fader): ensure the slide scrolls into view
        if (!images.hasAttribute('data-fader-mobile')) {
          scrollMediaIntoView(id);
        }
      });
    });

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === ATTR.activeMedia) {
          setActive(images.getAttribute(ATTR.activeMedia));
        }
      });
    });

    observer.observe(images, { attributes: true, childList: false, subtree: false });
    setActive(images.getAttribute(ATTR.activeMedia));

    // Slider mode: update dots while swiping through scroll-snap slides
    if (mediaList && !images.hasAttribute('data-fader-mobile') && 'IntersectionObserver' in window) {
      var slideObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.6) return;
            var id = entry.target.getAttribute(ATTR.mediaId);
            if (id) setActive(id);
          });
        },
        { root: mediaList, threshold: 0.6 }
      );

      mediaList.querySelectorAll('[' + ATTR.mediaId + ']').forEach(function (slide) {
        slideObserver.observe(slide);
      });
    }
  }

  function boot() {
    document.querySelectorAll(SELECTORS.dotsWrap).forEach(initDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var wrap = event.target.querySelector(SELECTORS.dotsWrap);
    if (wrap) initDots(wrap);
  });
})();
